import { Chip, type ChipProps } from '@ayble-health/dashboard-components';
import { LabResultStatus } from '../../../api/types';

const STATUS_VARIANT_MAP: Record<LabResultStatus, ChipProps['variant']> = {
  [LabResultStatus.OutOfRange]: 'ballet',
  [LabResultStatus.InRange]: 'mint',
  [LabResultStatus.Pending]: 'neutral',
  [LabResultStatus.Uploaded]: 'neutral',
};

type Props = {
  status: LabResultStatus;
};

/**
 * Renders a lab's `result_status` as a colored chip. The status values are
 * already display-ready, so the value doubles as the label.
 *
 * @example
 * <LabStatusChip status={LabResultStatus.OutOfRange} />
 */
export const LabStatusChip = ({ status }: Props) => (
  <Chip variant={STATUS_VARIANT_MAP[status]} fontSize={'2xs'}>
    {status}
  </Chip>
);
